<template>
  <v-container  fluid>
     <v-dialog v-model="showmefirst" persistent max-width="320px">
        <v-card>
           <v-col cols="12" sm="12" md="12" class="text-center">
              <img class="coupanimg" :src="coupanimg" />
              <div class="text-center infotext">You have just won <span class="specialfnt">5 units</span> in the team that is on this card</div>
            </v-col>
        </v-card>
      </v-dialog>
    <!-- Mobile verification: shown once the backend has accepted every field
         and texted a code. The account is not created until this passes. -->
    <v-dialog v-model="otpdialog" persistent max-width="420px">
      <v-card>
        <v-card-title class="justify-center">Verify your mobile</v-card-title>
        <v-card-text class="text-center">
          <p class="mb-4">
            We've sent a 6 digit code to <strong>{{ phone }}</strong>.
          </p>
          <div class="red--text mb-2">{{ otperror }}</div>
          <v-form @submit.prevent="verifyotp" ref="otpform" lazy-validation>
            <v-text-field v-model="otp" outlined hide-details="auto" maxlength="6" inputmode="numeric"
              label="Enter 6 digit code" :rules="otpRule" autofocus></v-text-field>
            <!-- local development only: the backend returns the code instead of texting it -->
            <div v-if="testcode" class="green--text text-left mt-2 caption">
              Test mode — SMS not delivered; use the code shown below.
              (test code: <strong>{{ testcode }}</strong>)
            </div>
            <v-btn type="submit" :loading="otploading" :disabled="otploading" color="primary"
              class="button__full x-large mt-4">Verify &amp; Create Account</v-btn>
          </v-form>
          <div class="mt-4">
            <span v-if="resendin > 0" class="grey--text">Resend code in {{ resendin }}s</span>
            <a v-else href="#" @click.prevent="resendotp" class="bluecolor">Resend code</a>
          </div>
          <div class="mt-2">
            <a href="#" @click.prevent="closeotp" class="grey--text">Change my details</a>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row align="center" justify="center">
       <v-col cols="12" sm="12" md="12" class="embed-container text-center" v-if="dialog">
         <vimeo-player class="vimeo" video-url="https://vimeo.com/576572843" ref="player" :video-id="videoID" @ended="ended" @ready="onReady" :autoplay="auto" :player-height="height" ></vimeo-player>
      </v-col>    
      <v-col cols="12" sm="6" md="6" v-show="showfirstvideo">
        <v-card class="customround">
          <v-row align="center" justify="center">
            <v-col cols="12" sm="10" md="10" class="text-center pt-5 pb-5">
              <img :src="logo" >
              <v-toolbar light flat  class="d-flex justify-space-around">
            <v-toolbar-title>Register</v-toolbar-title>
          </v-toolbar>
          <v-form @submit.prevent="validate" ref="form" lazy-validation>
            <v-alert ref="errorbox" v-if="errorlist.length" type="error" text dense class="text-left mb-0">
              <div v-for="(err, i) in errorlist" :key="i">{{ err }}</div>
            </v-alert>
            <v-card-text>
              <v-row>
                <v-col col="12" md="6" sm="6" class="">
                  <v-text-field v-model="firstname" class="pa-0" hide-details="auto" :rules="firstnameRule" outlined label="First Name *" required></v-text-field>
                </v-col>
                <v-col col="12" md="6" sm="6">
                  <v-text-field v-model="lastname" hide-details="auto" :rules="lastnameRule" outlined label="Surname *" required></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col col="12" md="6" sm="6">
                  <v-text-field v-model="email" :rules="emailRules" hide-details="auto"  outlined label="Email Address *" required></v-text-field>
                </v-col>
                <v-col col="12" md="6" sm="6">
                  <v-text-field v-model="phone" :rules="phoneRule" hide-details="auto" outlined label="Mobile *" placeholder="+14155551234"
                    persistent-hint hint="Include your country code — we'll text a code to verify it." required></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col col="12" md="6" sm="6">
                  <v-text-field v-model="dob" :rules="dobRule" hide-details="auto" outlined type="date" label="Date of Birth *"
                    :max="maxdob" required></v-text-field>
                </v-col>
                <v-col col="12" md="6" sm="6">
                  <v-text-field v-model="password" :rules="passwordRule" outlined hide-details="auto" label="Password *" @click:append="show1 = !show1" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" required></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col col="12" md="6" sm="6">
                  <v-text-field outlined hide-details="auto" label="Confirm Password *" v-model="confirmPassword" :rules="confirmPasswordRules" @click:append="show2 = !show2" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :type="show2 ? 'text' : 'password'" required ></v-text-field>
                </v-col>
                <v-col col="12" md="6" sm="6">
                  <v-select v-model="region" hide-details="auto"  outlined :rules="regionRule" @change="stateslist($event)" :items="regions" label="Country *" placeholder="Select country" required></v-select>
                </v-col>
              </v-row>
               <v-row>
                <v-col cols="12" md="6" sm="6">
                   <v-autocomplete id="stateid" hide-details="auto" @change="selectcities($event)" outlined :rules="stateidRule" v-model="stateid" :items="statesarr" item-text="state_name" item-value="state_id"
                       filled label="State / County *"  class="p-0" ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" sm="6">
                  <v-text-field hide-details="auto" outlined v-model="suburb" :rules="suburbRule" label="City or Suburb *" required></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" sm="6">
                  <v-text-field hide-details="auto" outlined v-model="postcode" :rules="postcodeRule" label="Post Code / Zip Code *" required></v-text-field>
                </v-col>
                <v-col cols="12" md="6" sm="6">
                  <v-text-field hide-details="auto" outlined v-model="captchaAnswer" :rules="captchaRule"
                    :label="'What is ' + captchaA + ' + ' + captchaB + '? *'" required></v-text-field>
                </v-col>
              </v-row>

            </v-card-text>
            <v-card-actions>
              <v-row dense>
                 <v-col col="12" md="12" sm="12">  
                   <v-btn type="submit" :loading="makedisable" :disabled="makedisable" class="button__full x-large" color="primary">Continue</v-btn>
                   <div class="mt-5">
                    Already have an account? <router-link :to="{ name: 'login'}" class="bluecolor">Login</router-link>

                   </div>
                 </v-col>
              </v-row>
            </v-card-actions>
          </v-form>
            </v-col> 
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//import DatePick from 'vue-date-pick';
//import 'vue-date-pick/dist/vueDatePick.css';

export default {
  name: "Register",
//  components: {DatePick},
  data() {
    return {
      showmefirst:false,
      videoID: '123',
      auto:true,
			height: 520,
      options:{ muted: true,autoplay: true,responsive: true},
      playerReady: false,
      logo: require("@/assets/logo.png"),
      coupanimg:require("@/assets/unnamed.png"),
      phone:"",
      region: "",
      username:"",
      regions: ["America", "Australia", "United Kingdom","New Zeland"],
      firstname: "",
      lastname: "",
      email: "",
      password: "",
      confirmPassword:"",
      gender:"",
      city:"", 
      stateid:"",
      cityname:"",
      suburb:"",
      postcode:"",
      statesarr:[],
       dob:"",
      captchaA:0,
      captchaB:0,
      captchaAnswer:"",
      otpdialog:false,
      otp:"",
      testcode:"",
      otperror:"",
      otploading:false,
      resendin:0,
      resendtimer:null,
      show1:false,
      show2:false,
      errorlist:[],
      makedisable:false,
      referral:"",
      showfirstvideo:false,
      dialog:false,
      qrcodescan:'',
      citiesarr:'',
      genderarr:["Male","Female","Other"],
      from_date: "",
      dollarref:0,
      usernameRule: [
        v => !!v || "Please enter username"
      ],
      firstnameRule: [
        v => !!v || "Please enter your first name"
      ],
      lastnameRule: [
        v => !!v || "Please enter your surname"
      ],
      dobRule: [
        v => !!v || "Please enter your date of birth"
      ],
      suburbRule: [
        v => !!v || "Please enter your city or suburb"
      ],
      postcodeRule: [
        v => !!v || "Please enter your post code / zip code"
      ],
      captchaRule: [
        v => !!v || "Please answer the question",
        v => parseInt(v, 10) === this.captchaA + this.captchaB || "That answer isn't correct"
      ],
      otpRule: [
        v => !!v || "Please enter the code we texted you",
        v => /^\d{6}$/.test(v || "") || "The code is 6 digits"
      ],
      emailRules: [
        v => !!v || "Please enter your email address",
        v =>
          /.+@.+\..+/.test(v) ||
          "This doesn't appear to be a valid email address"
      ],
       phoneRule: [
        v => !!v || "Please enter your phone number.",
        v => /^\+[1-9]\d{7,14}$/.test((v || "").replace(/[\s()-]/g, "")) ||
          "Include your country code, e.g. +14155551234"
      ],
      passwordRule: [
        v => v.length >= 6 || "Password must be at least 6 characters"
      ],
      confirmPasswordRules: [
        (value) => !!value || 'type confirm password',
        (value) =>
          value === this.password || 'The password confirmation does not match.',
      ],
      regionRule: [
        v => !!v || "Select the most accurate locale so we can provide you with more relevant questions"
      ],
       cityRule: [
        v => !!v || "Please Select the city."
      ],
      stateidRule: [
        v => !!v || "Please Select the state."
      ],
    };
  },
  computed: {
    maxdob() {
      // must be at least 18 years old
      var d = new Date();
      d.setFullYear(d.getFullYear() - 18);
      return d.toISOString().slice(0, 10);
    }
  },
  mounted(){
    this.newcaptcha();
    if(typeof this.$route.query.offer != "undefined")
    {
      
      this.showfirstvideo = false; 
      this.dialog = false;
      this.showmefirst = true;
      
        var self = this;
          setTimeout(function() {
               self.showmefirst = false;
               //self.showfirstvideo = false; 
               //self.dialog = true;
               self.showfirstvideo = true; 
         }, 5000);
    }
    else
    {
      this.showfirstvideo = true;
      this.dialog = false;
      this.showmefirst = false;
    }
    
  },
  beforeDestroy(){
    this.stopresendtimer();
  },
  methods: {
    newcaptcha(){
      this.captchaA = Math.floor(Math.random() * 9) + 1;
      this.captchaB = Math.floor(Math.random() * 9) + 1;
      this.captchaAnswer = "";
    },
    formatdate(event){
      var delimeter = "/";
       if(event.code != "Backspace")
       {
         if(this.dob.length == 2 || this.dob.length == 5)
         {
           this.dob = this.dob + delimeter;
         }
       }
       else
       {
          if(event.code == "Backspace")   
          {
             if(this.dob.length == 2)
            {
              this.dob = '';
            }
          } 
       }
    },
    onReady() {
			this.playerReady = true
    },
    play () {
			this.$refs.player.play()
		},
    ended(){
       this.dialog = false;
       this.showfirstvideo = true;
    },
		pause () {
			this.$refs.player.pause()
		},
    /*
     * Submit = step 1 only. The form is checked in the browser first, then the
     * backend re-validates everything and tells us whether the email / mobile
     * are already registered. Only once it has texted a code do we show the
     * OTP dialog; the account itself is created after the code checks out.
     */
    validate() {
      if (!this.$refs.form.validate()) {
        this.scrolltofirstinvalid();
        return;
      }
      this.errorlist = [];
      this.makedisable = true;

      this.$store.dispatch("sendRegisterOtp", {
          firstname: this.firstname,
          lastname : this.lastname,
          email    : this.email,
          phone    : this.phone,
          dob      : this.dob,
          password : this.password,
          region   : this.region,
          stateid  : this.stateid,
          suburb   : this.suburb,
          postcode : this.postcode,
        })
        .then(response => {
          this.makedisable = false;
          if (!response.data.status) {
            // email / mobile already registered, or a field the browser missed.
            // Leave the captcha alone - resetting it here fires a second red
            // error on a question the user already answered correctly.
            this.showerror(response.data.errors || response.data.message);
            return;
          }
          this.otp = "";
          this.otperror = "";
          this.testcode = this.readtestcode(response);
          this.otpdialog = true;
          this.startresendtimer();
        })
        .catch(error => {
          this.makedisable = false;
          this.showerror(this.readerror(error, "We could not start your registration. Please try again."));
        });
    },
    verifyotp() {
      if (!this.$refs.otpform.validate()) {
        return;
      }
      this.otperror = "";
      this.otploading = true;

      this.$store.dispatch("verifyRegisterOtp", { phone: this.phone, otp: this.otp })
        .then(response => {
          if (!response.data.status) {
            this.otploading = false;
            this.otperror = this.tolist(response.data.errors || response.data.message).join(" ");
            return;
          }
          // Mobile confirmed - now actually create the account.
          this.register();
        })
        .catch(error => {
          this.otploading = false;
          this.otperror = this.readerror(error, "We could not verify that code. Please try again.");
        });
    },
    resendotp() {
      if (this.resendin > 0) {
        return;
      }
      this.otperror = "";
      this.$store.dispatch("sendRegisterOtp", {
          firstname: this.firstname,
          lastname : this.lastname,
          email    : this.email,
          phone    : this.phone,
          dob      : this.dob,
          password : this.password,
          region   : this.region,
          stateid  : this.stateid,
          suburb   : this.suburb,
          postcode : this.postcode,
        })
        .then(response => {
          if (!response.data.status) {
            this.otperror = this.tolist(response.data.errors || response.data.message).join(" ");
            return;
          }
          this.otp = "";
          this.testcode = this.readtestcode(response);
          this.startresendtimer();
        })
        .catch(error => {
          this.otperror = this.readerror(error, "We could not resend the code. Please try again.");
        });
    },
    // local development only - empty unless the backend is in OTP test mode
    readtestcode(response) {
      var result = response && response.data ? response.data.result : null;
      return result && result.test_mode ? result.test_code : "";
    },
    closeotp() {
      this.otpdialog = false;
      this.otp = "";
      this.testcode = "";
      this.otperror = "";
      this.otploading = false;
      this.stopresendtimer();
    },
    startresendtimer() {
      this.stopresendtimer();
      this.resendin = 60;
      this.resendtimer = setInterval(() => {
        this.resendin--;
        if (this.resendin <= 0) {
          this.stopresendtimer();
        }
      }, 1000);
    },
    stopresendtimer() {
      if (this.resendtimer) {
        clearInterval(this.resendtimer);
        this.resendtimer = null;
      }
      this.resendin = 0;
    },
    readerror(error, fallback) {
      if (error && error.response && error.response.data && error.response.data.message) {
        return error.response.data.message;
      }
      return fallback;
    },
    // The form is taller than the viewport, so a failing field can be off-screen.
    scrolltofirstinvalid() {
      this.$nextTick(() => {
        var invalid = this.$el.querySelector(".v-input.error--text");
        if (invalid && this.$vuetify && this.$vuetify.goTo) {
          this.$vuetify.goTo(invalid, { duration: 300, offset: 100 });
        }
      });
    },
    /*
     * Show a form-level error. The message sits above a long form, so scroll it
     * into view - otherwise the submit just appears to do nothing.
     */
    showerror(message) {
      this.errorlist = this.tolist(message);
      this.$nextTick(() => {
        var box = this.$refs.errorbox;
        var el = box && box.$el ? box.$el : box;
        if (el && this.$vuetify && this.$vuetify.goTo) {
          this.$vuetify.goTo(el, { duration: 300, offset: 80 });
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      });
    },
    /*
     * Accepts the structured `errors` array, or falls back to splitting the
     * legacy <br>-joined `message` string so one message per line is shown
     * rather than raw markup.
     */
    tolist(message) {
      if (Array.isArray(message)) {
        return message;
      }
      return String(message || "")
        .split(/\s*<br\s*\/?>\s*/i)
        .map(m => m.trim())
        .filter(m => m.length);
    },
    register() 
    {
      if(typeof this.$route.query.invite != "undefined")
      {
         this.referral = this.$route.query.invite;    
      }
      if(typeof this.$route.query.offer != "undefined")
      {
         if(this.$route.query.offer == 'scanmest')
         {
             this.qrcodescan = this.$route.query.sp; 
         }
      }
      if(typeof this.$route.query.dollor != "undefined")
      {
         if(this.$route.query.dollor == 100)
         {
             this.dollarref = this.$route.query.dollor; 
         }
      }

      this.makedisable = true;
      this.$store.dispatch("register", {
          username  : this.username,
          firstname : this.firstname,
          lastname  : this.lastname,
          email     : this.email,
          password  : this.password,
          region    : this.region,
          referral  : this.referral,
          qrcodescan: this.qrcodescan,
          dob       : this.dob,
          gender    : this.gender,
          cityname  : this.suburb,
          suburb    : this.suburb,
          postcode  : this.postcode,
          stateid   : this.stateid,
          dollarref : this.dollarref,
          phone     : this.phone,
        })
        .then(response => {
          if(!response.data.status)
          {
             // e.g. the verification lapsed between verifying and submitting
             this.makedisable = false;
             this.otploading = false;
             this.closeotp();
             this.newcaptcha();
             this.showerror(response.data.errors || response.data.message);
          } 
          else
          {
            // this.$router.push({ name: "login" });
             this.closeotp();
             this.$store.dispatch("retrieveTokenRegister",
                {username: this.email,password: this.password,damnnid:response.data.result.dammNId}).then(() => {
                this.makedisable = false;
                this.$router.push({ name: "home" });
            }).catch((error) => {
             this.makedisable = false;
             this.showerror(this.readerror(error, "Your account was created but we could not sign you in. Please log in."));
            });
          }
        })
        .catch(error => {
          this.makedisable = false;
          this.otploading = false;
          this.closeotp();
          this.newcaptcha();
          this.showerror(this.readerror(error, "We could not create your account. Please try again."));
        })
    },
    selectcities(getstate)
    {
    
       this.$store
        .dispatch("citieslist", {
          stateid    : getstate,
          countryname: this.region,
        })
        .then(response => {
          this.citiesarr = response.data;
        })
        .catch(error => {
          // TODO: handle incorrect login
          console.log(error);
        });
    },
      stateslist(getcountry)
    {
       this.$store
        .dispatch("stateslist", {
          countryname: getcountry,
        })
        .then(response => {
          this.statesarr = response.data;
         })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("cities error from rigister");
          console.log(error);
        });
    }
  }
};
</script>
<style scoped>
.nopadding .v-text-field__details {
    display:none !important;
}
.button__full{width:96%;height:45px !important;}
.coupanimg {
  width: 100%;
  margin: auto;
}
.specialfnt {
  color: black;
  font-weight: bold;
  font-size: 15px;
}
</style>
<style>
.vimeo {
   height: 100%;
   width: 100% !important;
}
.vimeo > iframe {
    width: 100% !important;
}
.dobpicker input {
    font-size: 16px;
    display: block;
    width: 100%;
    box-sizing: border-box;
    padding: 5px;
    padding-right: 40px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 4px;
    background: transparent;
    /*border: 1px solid #9e9e9e;
    box-shadow: 0 0.1em 0.3em rgb(0 0 0 / 5%);*/
    outline: 0;
}
.vdpHeadCellContent{font-size: 12px;}
legend.myleg {
    text-align: left;
    margin-left: 16px;
    font-size: 13px;
    color: #707070;
}
</style>